<ion-header [translucent]="true" class="dashboard-header-wrapper">
  <ion-toolbar class="dashboard-toolbar">
    <div class="headerWrapper">
      <div class="menuWrapper">
        <app-logo customClass="mobLogo noMargin" [variant]="'mini'"></app-logo>
        <ion-button fill="clear" (click)="toggleMobileSidebar()" class="collapse-btn ion-no-padding">
          <ion-icon name="menu-outline" class="toggleMenuIcon"></ion-icon>
        </ion-button>
      </div>
      <div class="actionBtnListWrapper">
        <ion-icon name="search-outline" class="actionBtnListItem" *ngIf="false"></ion-icon>
        <ion-icon *ngIf="false" [name]="isDarkMode ? 'moon-outline' :'sunny-outline'" class="actionBtnListItem"
          (click)="toggleChange($event)" [attr.aria-label]="isDarkMode ? 'Dark Mode' : 'Light Mode'"></ion-icon>
        <!-- <ion-icon name="moon-outline" class="actionBtnListItem"></ion-icon> -->

        <div class="notification-icon-wrapper" (click)="toggleNotificationBar()">
          <ion-img src="assets/images/dashboard/notification.svg" alt="Notification"
            class="actionBtnListItem notification"></ion-img>
          <span *ngIf="unreadCount !== null && unreadCount !== undefined && unreadCount > 0" class="notification-dot"></span>
        </div>
      </div>
    </div>
    <!-- <ion-title class="dashboard-title">Main Layout</ion-title> -->
  </ion-toolbar>
</ion-header>

<app-sidebar (sidebarToggled)="onSidebarToggled($event)" (mobileSidebarToggled)="toggleMobileSidebar()"
  [customClass]="isMobSidebarVisible? 'isMobSidebarVisible': ''"></app-sidebar>
<app-notification-bar [(isNotificationBarCollapsed)]="isNotificationBarCollapsed"></app-notification-bar>

<ion-content [fullscreen]="true" class="dashboard-content-wrapper">
  <div class="overlay" *ngIf="isMobSidebarVisible" (click)="toggleMobileSidebar()"></div>
  <div class="dashboard-wrapper">
    <!-- Sidebar -->



    <!-- Main content -->
    <div class="dashboard-content" [class.collapsedActive]="isSidebarCollapsed">
      <ion-card class="dashboard-content-card">
        <ion-card-header class="content-title-wrapper headerWrapper">
          <div class="menuWrapper">
            <app-logo customClass="mobLogo noMargin" [variant]="'mini'"></app-logo>
            <ion-button fill="clear" (click)="toggleMobileSidebar()" class="collapse-btn ion-no-padding">
              <ion-icon name="menu-outline" class="toggleMenuIcon"></ion-icon>
            </ion-button>
          </div>

          <div class="mob-hide tab-hide">
            <ng-container *ngIf="isDashboard(); else innerPageHeader">
              <ion-card-title>
                Welcome back, {{userProfile?.name}}!
              </ion-card-title>
              <ion-card-subtitle>
                {{defaultDescription}}
              </ion-card-subtitle>
            </ng-container>
            <ng-template #innerPageHeader>
              <ion-card-title>
                {{ title }}
              </ion-card-title>
              <ion-card-subtitle>
                {{ description }}
              </ion-card-subtitle>
              <ion-card-subtitle class="viewingAccountSubtitle" *ngIf="isTransactions()">
                Viewing Account {{selectedAccount}}
              </ion-card-subtitle>
            </ng-template>
          </div>

          <div class="actionBtnListWrapper">
            <ion-icon name="search-outline" class="actionBtnListItem" *ngIf="false"></ion-icon>
            <ion-icon *ngIf="false" [name]="isDarkMode ? 'moon-outline' :'sunny-outline'" class="actionBtnListItem"
              (click)="toggleChange($event)" [attr.aria-label]="isDarkMode ? 'Dark Mode' : 'Light Mode'"></ion-icon>
            <!-- <ion-icon name="moon-outline" class="actionBtnListItem"></ion-icon> -->

            <div class="notification-icon-wrapper" (click)="toggleNotificationBar()">
              <ion-img src="assets/images/dashboard/notification.svg" alt="Notification"
                class="actionBtnListItem notification"></ion-img>
              <span *ngIf="unreadCount !== null && unreadCount !== undefined && unreadCount > 0" class="notification-dot"></span>
            </div>
          </div>
        </ion-card-header>

        <ion-card-content class="ion-no-padding ion-no-margin">
          <router-outlet (activate)="onPageActivate($event)"></router-outlet>
          <!-- <p>Layout page</p> -->
        </ion-card-content>
      </ion-card>
      <app-footer></app-footer>
    </div>
  </div>
</ion-content>




<div class="dashboard-content-wrapper" *ngIf="false">
  <app-sidebar></app-sidebar>

  <div class="dashboard-content" [class.collapsedActive]="isSidebarCollapsed">
    <router-outlet></router-outlet>
  </div>
</div>












<!-- To be deleted later by Bijay -->
<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>layout</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">layout</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content> -->